<template>
    <div class="w-full h-full">
        <FormModal v-if="showFilters" @cancel="showFilters = false; offerType = []; retailerCategory = undefined"
            @confirm="showFilters = false; this.getProgramOffers(0, 25)" :valid="true" title="Filter results"
            subtitle="Select from these filters to refine your search" submitButtonText="Apply filters">
            <div class="grid gap-3">
                <CustomCheckbox v-model="selectStatus" :options="statuses" label="Select offer status:" />
                <CustomCheckbox v-model="offerType" :options="offerTypes" label="Select offer types:" />
                <CustomSelect v-model="orderBy" :pre-select="orderBy" :options="orderByList" label="Order by:" />
            </div>
        </FormModal>
        <Header title="Cashback program" icon="BadgePercent" />
        <SubHeader v-if="!loading" :title="`Your program`" >
            <template v-slot:buttons>
                <CustomButton small id="createContract" :text="'Apply to more offers'" icon="Filter" type="navigate"
                    @click='$router.push("/retailer-catalogue")' />
            </template>
            <template v-if="!loading && programOfferStatistics != undefined" v-slot:stats>
                <StatBox class="col-span-4" name="Total live offers" :number="programOfferStatistics.totalActiveOffers" currency=""
                    icon="CircleHelp" />
                <StatBox class="col-span-1" name="Total offers" :number="programOfferStatistics.totalOffersApproved" currency=""
                icon="BadgeCheck" />
                <StatBox class="col-span-1"  name="Total payment linked offers"
                    :number="programOfferStatistics.totalPaymentLinkedOffersApproved" currency="" icon="CreditCard" />
                <StatBox  name="Total affiliate offers" :number="programOfferStatistics.totalOnlineOffersApproved"
                    currency="" icon="MousePointer2" />
                <StatBox  name="Total click to activate offers" :number="programOfferStatistics.totalClickToActivateApproved"
                currency="" icon="MousePointer2" />



            </template>

        </SubHeader>
        <WhiteBox v-if="!showDeactivatedOffers" title="Available offers"
            subText="Activate and deactivate your approved offers.">
            <template v-slot:buttons>
                <CustomButton small id="createContract" :text="'Filter by'" icon="Filter" type="action"
                    @click="showFilters = !showFilters" />
            </template>
            <template v-slot:content>
                <div v-if="offerType && offerType.length > 0 || selectStatus && selectStatus.length > 0"
                    class="flex justify-start items-center gap-2">
                    <p class="text-xs font-semibold min-w-[2.5rem]">Applied filters:</p>
                    <div class="flex justify-start items-center py-1 gap-1">
                        <div v-for="offer, index in offerType" :key="index">
                            <OfferTypePill :type="offer.id" />
                        </div>

                        <div v-for="status, index in selectStatus" :key="index">
                            <StatusPill v-if="status.id" text="Live" colour="green" />
                            <StatusPill v-else text="Deactivated" colour="yellow" />
                        </div>

                        <div class="flex items-center gap-1 px-1 py-0.5 bg-white border border-white w-min">
                            <p class="text-xs font-medium text-nowrap text-blue-600 underline hover:font-semibold cursor-pointer"
                                @click="offerType = []; selectStatus = []; orderBy = 'MOSTPOPULAR'; getProgramOffers(0, 25)">Clear filters
                            </p>
                        </div>
                    </div>
                </div>
                <div v-if="orderBy" class="flex justify-start items-center gap-2">
                    <p class="text-xs font-semibold min-w-[2.5rem]">Ordered By:</p>
                    <div class="flex justify-start items-center py-1 gap-1">


                        <div class="flex items-center gap-1 px-3 py-0.5 bg-gray-100 rounded-full border border-gray-400 w-min"
                            v-if="orderBy">
                            <p v-if="orderBy == 'MOSTPOPULAR'" class="text-xs font-medium text-nowrap">Most Popular</p>
                            <p v-if="orderBy == 'ATOZ'" class="text-xs font-medium text-nowrap">A to Z</p>
                            <p v-if="orderBy == 'ZTOA'" class="text-xs font-medium text-nowrap">Z to A</p>

                        </div>

                        <div class="flex items-center gap-1 px-1 py-0.5 bg-white border border-white w-min">
                        </div>
                    </div>
                </div>
                <div class="grid mt-6">
                    <SearchBar placeholderText="Search by retailer name"
                        @search="(val) => getRetailerBySearch(0, 50, val)">
                        <CustomButton small text="" type="default" icon="X" @click="getProgramOffers(0, 25)" />
                    </SearchBar>
                </div>
                <EasyDataTable :headers="headersTable1" :items="retailers" :loading="loading"
                    v-model:server-options="serverOptions" :server-items-length="serverItemsLength" :hide-footer="false"
                    :no-hover="true">
                    <template #loading>
                        <div class="p-4 w-full flex justify-center">
                            <svg class="animate-spin text-gray-400 w-12 h-12" xmlns="http://www.w3.org/2000/svg"
                                fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor"
                                    stroke-width="4"></circle>
                                <path class="opacity-75" fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
                                </path>
                            </svg>
                        </div>
                    </template>
                    <template #empty-message>
                        <div class="flex justify-center py-4">
                            <div
                                class="flex justify-center items-center text-gray-500 rounded-full bg-gray-50 px-5 py-2 ">
                                <p class="text-sm mr-2">No results</p>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
                                </svg>
                            </div>
                        </div>
                    </template>
                    <template #header-activate="header">
                        <div class="w-full text-right">
                            {{ header.text }}
                        </div>
                    </template>

                    <template #item-retailer="retailers">
                        <LogoAndText :logo="retailers.retailer.logo" :text="retailers.retailer.retailerName" />
                    </template>
                    <template #item-offertype="retailers">
                        <OfferTypePill :type="retailers.offer.offerType" />
                    </template>
                    <template #item-cashbackAmount="retailers">
                        <CashbackPill :text="retailers.displayRules[0].highestCashbackPercentageAmount"
                            :type="retailers.cashbackEarnings[0].conditions[0].value.type"
                            :currency="retailers.offer.currency" />
                    </template>
                    <template #header-active="header">
                        {{ header.text }}
                    </template>
                    <template #item-active="active">
                        <StatusPill v-if="active.active" text="Live" colour="green" />
                        <StatusPill v-else text="Deactivated" colour="yellow" />
                    </template>
                    <template #header-action="header">
                        <div class="w-full text-right">
                            {{ header.text }}
                        </div>
                    </template>
                    <template #item-action="retailers">
                        <div class="flex justify-end items-center py-1 gap-1">
                            <CustomButton small text="View Offer" type="navigate"
                                @click="$router.push(`/retailer/${retailers.retailer.id}/offer/${retailers.offer.id}`)" />
                            <CustomButton :requiresConfirmation="true" confrimationModalTitle="Activate this offer"
                                confrimationModalMessage="Confirm you would like to activate this offer"
                                confrimationModalButtonText="Activate" v-if="!retailers.active" small text="Activate"
                                type="action" @confirmClick="activateOffer(retailers.id)" />
                            <CustomButton v-else small text="Deactivate" type="warning"
                                @confirmClick="deActivateOffer(retailers.id)" :requiresConfirmation="true"
                                confrimationModalTitle="Deactivate this offer"
                                confrimationModalMessage="Confirm you would like to deactivate this offer"
                                confrimationModalButtonText="Deactivate" />
                        </div>
                    </template>
                    <template #item-date="retailers">
                        <div class="flex justify-end items-center py-1 gap-1">
                            {{ niceDateTime(retailers.createdOn) }}
                        </div>
                    </template>
                </EasyDataTable>
            </template>
        </WhiteBox>
    </div>
</template>

<script setup>
</script>

<script>
import Header from "@/components/Header.vue";
import SearchBar from '@/components/SearchBar.vue'

import WhiteBox from "@/components/WhiteBox.vue";
import CustomButton from "@/components/inputs/CustomButton.vue";
import SubHeader from "@/components/SubHeader.vue";
import FormModal from "@/components/modals/FormModal.vue";

import LogoAndText from "@/components/LogoAndText.vue";
import StatusPill from "@/components/StatusPill.vue";
import CashbackPill from "@/components/CashbackPill.vue";
import OfferTypePill from "@/components/OfferTypePill.vue";
import { DateTime } from 'luxon';
import StatBox from "@/components/StatBox.vue";

import CustomCheckbox from "@/components/inputs/CustomCheckbox.vue";
import CustomSelect from "@/components/inputs/CustomSelect.vue";

export default {
    name: "manage-publsihers",
    components: {
        FormModal,
        Header,
        WhiteBox,
        CustomButton,
        SearchBar,
        SubHeader,
        LogoAndText,
        StatusPill,
        CashbackPill,
        OfferTypePill,
        StatBox,
        CustomCheckbox,
        CustomSelect
    },
    props: {
    },

    data() {
        return {
            programOfferStatistics: undefined,
            showFilters: false,
            serverOptions: {
                page: 1,
                rowsPerPage: 25,
            },
            successAction: "",
            serverItemsLength: undefined,
            showSuccessModal: false,
            loading: true,
            headersTable1: [
                { text: "Retailer", value: "retailer" },
                { text: "Status", value: "active" },
                { text: "Type", value: "offertype" },
                { text: "Cashback", value: "cashbackAmount" },
                { text: "Action", value: "action" },
            ],
            retailers: [],
            serverItemsLengthDeactive: undefined,
            serverOptions2: {
                page: 1,
                rowsPerPage: 25,
            },
            deactivated: [],
            orderByList: [
                { "id": "MOSTPOPULAR", "text": "Most Popular" },
                { "id": "ATOZ", "text": "A to Z" },
                { "id": "ZTOA", "text": "Z to A" }
            ],
            offerTypes: [
                { id: "PAYMENT", text: 'Payment-linked offers' },
                { id: "ONLINE", text: 'Affiliate links' },
                { id: "CLICK_TO_ACTIVATE", text: 'Click to activate' },

            ],
            statuses: [
                { id: true, text: 'Live' },
                { id: false, text: 'Deactivated' },
            ],

            activeFilters: [
                { id: "PAYMENT", filter: true },
                { id: "ONLINE", filter: true },
                { id: "GIFTCARD", filter: true },
                { id: "CLICK_TO_ACTIVATE", text: 'Click to activate' },
                { id: "Category", filterText: "Restaurant" },
            ],
            offerType: [],
            selectStatus: [],
            orderBy: "MOSTPOPULAR",
        }
    },
    created() {
        this.getProgramOfferStatistics()
        this.getProgramOffers(0, 25)

    },
    methods: {

        async getProgramOfferStatistics() {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/activated-offer/statistics`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.programOfferStatistics = object
                }

            } catch {
                return
            }
        },


        niceDateTime(dateObject) {
            return DateTime.fromMillis(dateObject).toLocaleString(DateTime.DATETIME_MED)
        },

        async getRetailerBySearch(page, size, retailerSearch) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/activated-offer/retailer-search?page=${page}&size=${size}&search=${retailerSearch}&category=`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()
                    this.retailers = object.content
                    this.serverItemsLength = object.totalElements
                    this.loading = false
                }

            } catch {
                return
            }
        },

        async activateOffer(offerId) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/activated-offer/offer/activate/${offerId}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.successAction = "Offer Activated"
                    this.getProgramOffers(0, 25)
                    this.showSuccessModal = true
                }

            } catch {
                return
            }
        },

        async deActivateOffer(offerId) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/activated-offer/offer/deactivate/${offerId}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    this.getProgramOffers(0, 25)
                    this.successAction = "Offer deactivated"
                    this.showSuccessModal = true
                }

            } catch {
                return
            }
        },



        async getProgramOffers(page, size) {
            try {
                const token = localStorage.getItem('token')
                const api = localStorage.getItem('apiType')

                this.loading = true

                if (this.offerType.length > 0) {
                    var offerType = []
                    this.offerType.forEach(element => {
                        offerType.push(element.id)
                    });
                }

                if (this.selectStatus.length > 0) {
                    var selectStatus = []
                    this.selectStatus.forEach(element => {
                        selectStatus.push(element.id)
                    });
                }


                const response = await this.$apiFetch(`https://${api}.boogi.io/private/api/client/activated-offer?page=${page}&size=${size}&type=${this.offerType.length > 0 ? offerType : ''}&sort=${this.orderBy}&status=${this.selectStatus.length > 0 ? selectStatus : ''}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `${token}`,
                    },
                });

                if (response.ok) {
                    var object = await response.json()

                    this.serverItemsLength = object.totalElements
                    this.retailers = object.content

                    this.loading = false
                }

            } catch (error) {
                return;
            }

        }
    },
    computed: {

    },
    mounted() {
        document.title = "Dashboard | Program offers";
    },
    watch: {
        serverOptions: {
            deep: true,
            handler(val) {
                this.getProgramOffers(val.page - 1, val.rowsPerPage)
            }
        }
    }
}
</script>